import React, { useContext } from 'react';
import { Marker } from '@react-google-maps/api';
import { Box, Typography, Stack, Divider } from '@mui/material';
import LayersContext from '../../context/LayersContext';

const STATIONS = [
    {
        id: 'metra-station-ogilvie',
        name: 'Ogilvie Transportation Center',
        iconPoint: { latitude: 41.88322154711984, longitude: -87.6406336646382 }
    },
    {
        id: 'metra-station-union',
        name: 'Union Station',
        iconPoint: { latitude: 41.87860776539295, longitude: -87.640334948577 }
    },
    {
        id: 'metra-station-millennium',
        name: 'Millennium Station',
        iconPoint: { latitude: 41.88436322168539, longitude: -87.62472646886869 }
    }
];

const getStationIcon = () => ({
    url: '/mapicons/train/MetraStation.png',
    anchor: new window.google.maps.Point(12, 12),
    scaledSize: new window.google.maps.Size(24, 24)
});

const StationInfoWindow = (props) => {
    const obj = props.icon;
    return (
        <Box className="map-popup-text" sx={{ maxWidth: 300 }}>
            <Stack spacing={1.5} sx={{ minWidth: 200 }}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <img src="/mapicons/train/MetraStation.png" alt="Metra Station" style={{ width: 24, height: 24 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Metra Station
                        </Typography>
                    </Box>
                </Box>
                <Stack spacing={1}>
                    <Typography variant="body2">
                        &bull; {obj.name}
                    </Typography>
                </Stack>
                <Divider />
            </Stack>
        </Box>
    );
};

const stationModule = {
    infoWindow: StationInfoWindow
};

export default function MetraStations(props) {
    const layersContext = useContext(LayersContext);
    const module = props.module;
    const title = module.name;
    const setSelectedMarker = props.setSelectedMarker;

    const enabled = layersContext && layersContext[title] && layersContext[title].enabled;
    if (!enabled) {
        return null;
    }

    return (
        <>
            {STATIONS.map(station => (
                <Marker
                    key={station.id}
                    position={{ lat: station.iconPoint.latitude, lng: station.iconPoint.longitude }}
                    icon={getStationIcon()}
                    title={station.name}
                    onClick={() => setSelectedMarker({ icon: station, module: stationModule })}
                />
            ))}
        </>
    );
}
